<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Icon from 'dashboard/components-next/icon/Icon.vue';

const props = defineProps({
  password: { type: String, default: '' },
});
const MIN_PASSWORD_LENGTH = 6;
const SPECIAL_CHAR_REGEX = /[!@#$%^&*()_+\-=[\]{}|'"/\\.,`<>:;?~]/;

const { t } = useI18n();

const requirements = computed(() => {
  const password = props.password || '';
  return [
    {
      id: 'length',
      met: password.length >= MIN_PASSWORD_LENGTH,
      label: t('REGISTER.PASSWORD.REQUIREMENTS_LENGTH', {
        min: MIN_PASSWORD_LENGTH,
      }),
    },
    {
      id: 'no_special',
      met: password.length > 0 && !SPECIAL_CHAR_REGEX.test(password),
      label: t('REGISTER.PASSWORD.REQUIREMENTS_NO_SPECIAL'),
    },
  ];
});
</script>

<!-- 与登录/注册页一致的浅色风格, 强制不跟随系统 dark mode -->
<!-- eslint-disable vue/no-static-inline-styles -->
<template>
  <div
    class="absolute top-0 z-50 w-64 text-xs rounded-lg px-4 py-3 start-full ms-4"
    style="
      background-color: #ffffff;
      border: 1px solid #e5e7eb;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    "
  >
    <ul role="list" class="space-y-1.5">
      <li
        v-for="item in requirements"
        :key="item.id"
        class="flex gap-1.5 items-start"
      >
        <Icon
          class="flex-none flex-shrink-0 w-3 mt-0.5"
          :icon="item.met ? 'i-lucide-circle-check-big' : 'i-lucide-circle'"
          :style="{ color: item.met ? '#10b981' : '#9ca3af' }"
        />
        <span :style="{ color: item.met ? '#1f2937' : '#6b7280' }">
          {{ item.label }}
        </span>
      </li>
    </ul>
  </div>
</template>
